import React from 'react';
import {
  EVBox,
  EVTypography,
  EVGrid,
  EVButton,
} from '@eagleview/ev-comp-library';
import { useHistory, useLocation } from 'react-router-dom';
import { FORGOT_PWD_LINK, LOGIN_URL } from '../../constants/AppConstants';
import useStyles from './SuccessStyle';
import evLogo from '../../assets/images/evLogo.svg';

const Success = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { state } = location;

  if (!state) {
    history.push('/');
    return null;
  }

  const handleRedirectClick = () => {
    window.location.href = `${FORGOT_PWD_LINK}`;
  };

  const handleLoginRedirectClick = () => {
    window.location.href = `${LOGIN_URL}`;
  };

  return (
    <EVBox wrap="nowrap" className={classes.topContainer}>
      <EVGrid
        container
        wrap="nowrap"
        style={{
          flexDirection: 'row',
          height: '100%',
          position: 'relative',
        }}
      >
        <EVGrid style={{
          flexGrow: 1,
          position: 'static',
          backgroundRepeat: 'no-repeat',
          backgroundImage: 'url(/assets/images/evbackground.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: '50%',
        }}
        />
        <EVGrid className={classes.formMainContainer}>
          <EVGrid className={classes.evLogoContainer}>
            <img
              src={evLogo}
              alt="EagleView"
              className={classes.logo}
            />
          </EVGrid>
          <EVGrid className={classes.formContainer}>
            { state.userCreated && !state.orgCreated && !state.activationEmailSent
              ? (
                <EVGrid container style={{ flexDirection: 'column', gap: '16px', alignItems: 'flex-start' }}>
                  <EVGrid container style={{ flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
                    <EVTypography className={classes.successHeader}>Account created successfully!</EVTypography>
                    <EVTypography className={classes.text}>
                      Your account has been set up and you can now use your credentials to log in to your Eagleview account.
                    </EVTypography>
                  </EVGrid>
                  <EVButton variant="contained" color="primary" className={classes.button} onClick={handleLoginRedirectClick}>
                    Log In
                  </EVButton>
                </EVGrid>
              )
              : !state.userCreated && !state.orgCreated
                ? (
                  <EVGrid container style={{ flexDirection: 'column', gap: '16px', alignItems: 'flex-start' }}>
                    <EVGrid container style={{ flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
                      <EVTypography className={classes.successHeader}>Existing email</EVTypography>
                      <EVTypography className={classes.text}>
                        User with email
                        {' '}
                        <span className={classes.emailText}>{state.email}</span>
                        {' '}
                        already exists on Eagleview.
                        <br />
                        You can sign in using your existing credentials or reset your password from here.
                      </EVTypography>
                    </EVGrid>
                    <EVButton variant="contained" color="primary" className={classes.button} onClick={handleRedirectClick}>
                      Reset Password
                    </EVButton>
                    <EVTypography className={classes.noteText}>
                      Note: Federated users can use their SSO credentials to sign in
                    </EVTypography>
                  </EVGrid>
                )
                : (
                  <EVGrid container style={{ flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
                    <EVTypography className={classes.successHeader}>Verify your email</EVTypography>
                    <EVTypography className={classes.text}>
                      Almost done! An activation email was sent to
                      {' '}
                      <span className={classes.emailText}>{state.email}</span>
                      .
                      You need to verify your email address to complete your account activation.
                      This link will expire in 7 days.
                    </EVTypography>
                  </EVGrid>
                )}
          </EVGrid>
        </EVGrid>
      </EVGrid>
    </EVBox>
  );
};

export default Success;
